import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'wk-clean-up-comments',
  templateUrl: 'wk-clean-up-comments.dialog.html',
  styleUrls: ['./wk-clean-up-comments.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WkCleanUpCommentsComponent {
  constructor(
    private readonly wkdialogRef: MatDialogRef<WkCleanUpCommentsComponent>
  ) {}

  closeCleanUpCommentsDialog() {
    this.wkdialogRef.close();
  }

  deleteEditorialComments() {
    this.wkdialogRef.close('deleteComments');
  }
}
